import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { orderList, expressQuery } from '@/api';
import { invoke } from 'wecom-sidebar-jssdk';
import { Tabs, message, Descriptions, Card, Table, Form, Row, Col, Input, Button, Select, Divider, Space, Modal } from 'ant-design-vue';
let ExternalUser = class ExternalUser extends Vue {
    constructor() {
        super(...arguments);
        this.externalUser = {};
        this.activeKey = '1';
        this.expressQueryData = {};
        this.open = false;
        this.orderListData = {};
        this.searchForm = {
            page: 1,
            limit: 1000,
            external_userid: '',
            order_sn: '',
            pay_status: ''
        };
    }
    onClose() {
        this.open = false;
    }
    async onShow(order_id) {
        const res = await invoke('getCurExternalContact', {});
        if (!res || !res.userId)
            return;
        console.log('外部联系人 ID', res.userId);
        this.expressQueryData = await expressQuery({
            order_id: order_id,
            external_userid: res.userId
        });
        this.open = true;
    }
    async getOrderList() {
        try {
            const res = await invoke('getCurExternalContact', {});
            if (!res || !res.userId)
                return;
            console.log('外部联系人 ID', res.userId);
            this.searchForm.external_userid = res.userId;
            this.orderListData = await orderList(this.searchForm);
        }
        catch (e) {
            message.error(e);
        }
    }
    async mounted() {
        // await this.getExternalUserInfo()
        await this.getOrderList();
    }
};
ExternalUser = __decorate([
    Component({
        name: 'ExternalUser',
        components: {
            'a-modal': Modal,
            'a-divider': Divider,
            'a-space': Space,
            'a-tabs': Tabs,
            'a-card': Card,
            'a-tab-pane': Tabs.TabPane,
            'a-descriptions': Descriptions,
            'a-descriptions-item': Descriptions.Item,
            'a-table': Table,
            'a-form': Form,
            'a-form-item': Form.Item,
            'a-row': Row,
            'a-col': Col,
            'a-input': Input,
            'a-button': Button,
            'a-select': Select,
            'a-select-option': Select.Option,
        }
    })
], ExternalUser);
export default ExternalUser;
